import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import { EVENT_GET_DETAIL_BOT_LOG } from '../../configs/EventTypes';

var base64 = require('base-64');
var utf8 = require('utf8');

class SearchTablePage extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            searchResult:[],
            page:0,
            rowsPerPage: 10,

        }
        this.handlerClick=this.handlerClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.tablesearch !== this.state.searchResult) {

            this.setState({
                searchResult: nextProps.tablesearch,
                page:0
            })
        }
    }

     handleChangePage(event, newPage, pageName) {
        this.setState({
            [pageName]: newPage
        })
    }

    handleChangeRowsPerPage(event, pageName, rowsPerPageName) {
        this.setState({
            [rowsPerPageName]: +event.target.value,
            [pageName]: 0
        })
    }

    handlerClick(rowIndex, transactionNo) {

        //console.log(rowIndex)
        //console.log(transaction_no)

        const { searchResult} = this.state;
        let { history } = this.props;
        if (transactionNo !== '') {
            var clickRowOntask = searchResult.filter((data) => {
                return data.transaction_no && data.transaction_no === transactionNo
            })

            if (clickRowOntask.length > 0) {

                let bytes_tran_no = utf8.encode(clickRowOntask[0].transaction_no);
                let encoded_transaction_no = base64.encode(bytes_tran_no);

                let bytes_po_contract_no = utf8.encode(clickRowOntask[0].po_contract_no);
                let encoded_po_contract_no = base64.encode(bytes_po_contract_no)

                history.push({
                    pathname: '/main',
                    search: `?mode=EDIT&transaction_no=${encoded_transaction_no}&po_no=${encoded_po_contract_no}`,
                    state: { searchResult: clickRowOntask[0], mode: 'EDIT' }
                });
            }
        }
    }

    setDetailBotLogModal(type, transaction_no = "") {
      
        window.emitter.emit(EVENT_GET_DETAIL_BOT_LOG, {
            transaction_no: transaction_no
        })

        window.$('#DetailBotLogModal').modal('show');
    }

    render() {

        const { searchResult, page, rowsPerPage } = this.state
        const {isAdmin} = this.props
        console.log("searchResult")
        console.log(searchResult)
        return (
            <Paper>
                <div className="row no-gutters sp-table-content " style={{ minWidth: '2500px' }} >
                    <Table className="sp-table table rrs-table" >
                        <TableHead>
                            <TableRow className="sp-table-header">
                                <TableCell className="th-table text-center" style={{ width: '50px' }} >No.</TableCell>
                                {isAdmin == true && (
                                    <TableCell className="th-table text-center" style={{ width: '100px' }} >Detail</TableCell>
                                )}
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >MOM Doc No.</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >RRS Doc No.</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >สถานะเอกสาร</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >RRS Create By</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >RRS Create Date</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >RRS Edit By</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >RRS Edit Date</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >PO/Contract</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >ผู้สร้าง PO/Contract</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >Purch. Group</TableCell>
                                {/* <TableCell className="th-table text-center" style={{ width: '100px' }} >Requisitioner</TableCell> */}
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >GR Header Text</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >GR Delivery Note/Reference</TableCell>
                                {/* <TableCell className="th-table text-center" style={{ width: '100px' }} >Goods Recipient</TableCell> */}
                                {/* <TableCell className="th-table text-center" style={{ width: '100px' }} >GR Plant</TableCell> */}
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >IR Reference</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >Invoice Date</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >IR Posting Date</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >Vendor Name</TableCell>
                                </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                searchResult ? (
                                    searchResult.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((task, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}style={{ cursor: 'pointer' }} */  className="text-center">{(page * rowsPerPage) + (index + 1)}</TableCell>
                                                    {isAdmin == true && (
                                                        <TableCell className="action-icon">
                                                            <a href="#" onClick={() => this.setDetailBotLogModal("item", task.transaction_no)} data-toggle="modal" >
                                                                <i className="icon bt-edit" />
                                                            </a>
                                                        </TableCell>
                                                    )}
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}style={{ cursor: 'pointer' }} */  className="text-center" >{task.mom_no}</TableCell>
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}style={{ cursor: 'pointer' }} */  className="text-center" >{task.doc_no}</TableCell>
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}*/ style={{ "whiteSpace": "nowrap" }}>{task.status}</TableCell>
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}*/ style={{ "whiteSpace": "nowrap" }}>{task.create_by}</TableCell>
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}style={{ cursor: 'pointer' }} */  className="text-center">{task.creat_date ?  moment(task.creat_date).format('DD/MM/YYYY') : ''}</TableCell>
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}*/ style={{ "whiteSpace": "nowrap" }}>{task.edit_by}</TableCell>
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}style={{ cursor: 'pointer' }} */  className="text-center">{task.edit_date ?  moment(task.edit_date).format('DD/MM/YYYY') : ''}</TableCell>
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}style={{ cursor: 'pointer' }} */  className="text-center">{task.po_contract_no}</TableCell>
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}*/ style={{ "whiteSpace": "nowrap" }}>{task.po_header_text}</TableCell>
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}style={{ cursor: 'pointer' }} */  className="text-center">{task.po_pur_ch_group}</TableCell>
                                                    {/* <TableCell className="text-center">{task.requisitioner}</TableCell> */}
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}*/ style={{ "whiteSpace": "nowrap" }}>{task.doc_text}</TableCell>
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}style={{ cursor: 'pointer' }} */  className="text-center">{task.delivery_note}</TableCell>
                                                    {/* <TableCell className="text-center">{task.goods_recipient}</TableCell>
                                                    <TableCell className="text-center">{task.plant}</TableCell> */}
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}style={{ cursor: 'pointer' }} */  lassName="text-center">{task.invoice_no}</TableCell>  
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}style={{ cursor: 'pointer' }} */  lassName="text-center">{task.invoice_date ?  moment(task.invoice_date).format('DD/MM/YYYY') : ''}</TableCell> 
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}style={{ cursor: 'pointer' }} */  lassName="text-center">{task.posting_date ?  moment(task.posting_date).format('DD/MM/YYYY') : ''}</TableCell>   
                                                    <TableCell /*onClick={() => { this.handlerClick(index, task.transaction_no) }}*/ style={{ "whiteSpace": "nowrap" }}>{task.vendor_name}</TableCell> 
                                                      

                                                    {/* <TableCell className="text-center">{task.po_contract_no}</TableCell>
                                                    <TableCell style={{ "whiteSpace": "nowrap" }}>{task.po_header_text}</TableCell>
                                                    <TableCell className="text-left">{task.vendor_name}</TableCell>
                                                    <TableCell className="text-left">{task.status_name}</TableCell>
                                                    <TableCell className="text-left">{task.method}</TableCell>
                                                    <TableCell className="text-center">{'Ref./Invoice No'}</TableCell>
                                                    <TableCell className="text-center">{task.createby}</TableCell>
                                                    <TableCell className="text-left" style={{ "whiteSpace": "nowrap" }}>{task.goods_receipe}</TableCell>
                                                    <TableCell className="text-left">{task.create_po_contract_emp_name}</TableCell>
                                                    <TableCell className="text-center" >{moment(task.posting_date).format('DD/MM/YYYY')}</TableCell>
                                                    <TableCell className="text-center">{moment(task.po_date).format('DD/MM/YYYY')}</TableCell> */}
                                                </TableRow>
                                            );
                                        })) : (
                                        <TableRow key={0}>
                                            <TableCell colSpan="11" className="text-center" style={{
                                                textAlign: 'center',
                                                fontStyle: 'italic',
                                                color: 'gray'
                                            }}>No data</TableCell>
                                        </TableRow>
                                    )
                            }

                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        component="div"
                        count={searchResult.length}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                            'aria-label': 'previous page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'next page',
                        }}
                        onChangePage={(event, newPage) => this.handleChangePage(event, newPage, "page")}
                        onChangeRowsPerPage={(event) => this.handleChangeRowsPerPage(event, "page", "rowsPerPage")}
                    />
                </div>
            </Paper>
        );

    }


}
export default SearchTablePage